import { Observable, of } from 'rxjs';

import { IUser, User } from '../user/user';

export interface INotificationMeeting {
	readonly coachId: string;
	readonly startDate: Date;
	readonly endDate: Date;
	readonly coach$: Observable<IUser>;
}

export class NotificationMeeting implements INotificationMeeting {
	private _coachId: string;
	private _startDate: Date;
	private _endDate: Date;
	private _coach$: Observable<User>;

	constructor(
		coachId: string,
		startDate: Date,
		endDate: Date,
		coach$: Observable<User> = of(null)
	) {
		this._coachId = coachId;
		this._startDate = startDate;
		this._endDate = endDate;
		this._coach$ = coach$;
	}

	public get coachId(): string {
		return this._coachId;
	}

	public get startDate(): Date {
		return this._startDate;
	}

	public get endDate(): Date {
		return this._endDate;
	}

	public get coach$(): Observable<User> {
		return this._coach$;
	}
}
